import * as keyapis_dadata_v1_sync_pb from "./v1/keyapis_dadata_sync_v1.pb";

export default {
  v1: {
    resources: {
      sync: keyapis_dadata_v1_sync_pb,
    },
  },
};
